import { Component, OnInit, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ManualUploadProcStatusService } from './manual-upload-proc-status.service';

export interface UploadProcEditData {
  upload_id:     number;
  upload_type:   string;
  upload_status: string;
  remarks:       string;
}

@Component({
  selector: 'app-manual-upload-proc-status-edit-dialog',
  templateUrl: './manual-upload-proc-status-edit-dialog.component.html',
  standalone: false
})
export class ManualUploadProcStatusEditDialogComponent implements OnInit {

  readonly STATUS_OPTIONS = ['STARTED', 'INITIATED', 'IN_PROGRESS', 'COMPLETED', 'ERROR'];

  eStatus  = '';
  eRemarks = '';
  errorMessage = '';
  spinnerMessage = 'Please Wait...';

  readonly data: UploadProcEditData = inject(MAT_DIALOG_DATA);

  constructor(
    private service: ManualUploadProcStatusService,
    private spinnerService: NgxSpinnerService,
    public dialogRef: MatDialogRef<ManualUploadProcStatusEditDialogComponent>
  ) {}

  ngOnInit(): void {
    this.eStatus  = this.data.upload_status;
    this.eRemarks = this.data.remarks || '';
  }

  save(): void {
    this.errorMessage = '';
    this.spinnerService.show();
    this.service.updateUploadProcStatus(this.data.upload_id, this.eStatus, this.eRemarks).subscribe({
      next: (res: any) => {
        this.spinnerService.hide();
        if (res?.payload?.[0]?.result === 'success') {
          this.dialogRef.close('success');
        } else {
          this.errorMessage = 'Update failed. Please try again.';
        }
      },
      error: () => {
        this.spinnerService.hide();
        this.errorMessage = 'Update failed. Please try again.';
      }
    });
  }

  cancel(): void { this.dialogRef.close(); }
  closeAlert(): void { this.errorMessage = ''; }
}
